import { masterV2Api } from "@/apis/interceptor"
import { IOperatorResponse, IPaginationParamV2, IResponse } from "@/types"

export const operatorsService = {
  getOperators: async (params: IPaginationParamV2): Promise<IResponse<IOperatorResponse>> => {
    const response = await masterV2Api.get<IResponse<IOperatorResponse>>("/v1/operators", { params })
    return response.data
  },
}
